import { useState } from "react";
import { Menu, X, LogOut } from "lucide-react";
import { SidebarProvider } from "../components/ui/sidebar.tsx";
import { AppSidebar } from "../components/AppSidebar.jsx";
import {Toaster} from "@/components/ui/sonner";
import logo from "@/assets/ramsden-light.png";

export default function AdminDashboard({ children }) {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = async () => {
        try {
            const csrf = document.querySelector("meta[name='csrf-token']")?.content;
            const res = await fetch("/users/sign_out", {
                method: "DELETE",
                headers: {
                    "X-CSRF-Token": csrf,
                },
                credentials: "include",
            });
            if (res.ok) {
                window.location.href = "/admin/login"; // or use `navigate()` if using React Router
            }
        } catch (err) {
            console.error("Logout failed", err);
        }
    };

    return (
        <SidebarProvider>
            <div className="flex h-screen w-screen bg-gradient-to-br from-[#fefcfd] to-[#f5f1f3] text-gray-900">
                {/* Sidebar: Desktop */}
                <aside className="hidden md:flex md:w-64 border-r border-gray-200 bg-white shadow-sm z-20">
                    <AppSidebar />
                </aside>

                {/* Mobile Sidebar Toggle */}
                <div className="md:hidden absolute top-4 left-4 z-30">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="p-2 rounded-xl shadow-md bg-white hover:bg-gray-50 transition"
                    >
                        <Menu className="h-6 w-6 text-gray-700" />
                    </button>
                </div>

                {/* Mobile Sidebar Drawer */}
                {isSidebarOpen && (
                    <div
                        className="fixed inset-0 z-40 flex bg-black/40 backdrop-blur-sm"
                        onClick={() => setSidebarOpen(false)}
                    >
                        <div
                            className="w-64 h-full bg-white shadow-xl rounded-r-xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex justify-end p-4">
                                <button
                                    onClick={() => setSidebarOpen(false)}
                                    className="text-gray-500 hover:text-gray-800 transition"
                                >
                                    <X className="h-5 w-5" />
                                </button>
                            </div>
                            <AppSidebar />
                        </div>
                    </div>
                )}

                {/* Main Content Area */}
                <div className="flex flex-col flex-1 overflow-hidden">
                    <Toaster />
                    {/* Header */}
                    <header className="sticky top-0 z-10 bg-[#8C3161] text-white px-6 py-4 shadow-md flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <img
                                src={logo}
                                alt="Ramsden Logo"
                                className="h-6 w-auto filter brightness-0 invert"
                            />
                            <h1 className="text-xl font-semibold tracking-tight">Ramsden Admin</h1>
                        </div>
                        <button
                            onClick={handleLogout}
                            className="flex items-center gap-2 text-sm hover:underline hover:text-gray-100 transition"
                        >
                            <LogOut className="w-4 h-4" />
                            Log out
                        </button>
                    </header>

                    {/* Page Content */}
                    <main className="flex-1 overflow-auto px-4 py-6 md:px-8 md:py-10">
                            <div className="mx-auto w-full max-w-6xl">{children}</div>
                    </main>
                </div>
            </div>
        </SidebarProvider>
    );
}
